import { render, staticRenderFns } from "./DocumentsCollaborateurs.vue?vue&type=template&id=747eb3b0&"
import script from "./DocumentsCollaborateurs.vue?vue&type=script&lang=js&"
export * from "./DocumentsCollaborateurs.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCollaborateurs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports